import "../../../assets/css/SalesTrend/FilterBar.css";
import React, { useState, useEffect } from "react";
import FilterListIcon from "../../../assets/images/FilterImg.svg";
import {
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  ListItemText,
  Box,
  Grid,
 
} from "@mui/material";
import { renderLoadingOrEmptyState } from "../../../utils/loadingUtils";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../../config/config";
import { useSalesContext } from "../../SalesContext";
import {getAllFilterOptions,getCodeMappings,getRelatedSelections} from "./index"
import StyledButton from '../../../styledComponent/StyledButton';


const MultiFilterSelect = ({ user_id, apiEndpoint }) => {
  const { updateSalesUnit, setKpiData, setLoading,setSelectedMRs,selectedMRs } = useSalesContext();
  const { userId } = useParams();
  const [filterData, setFilterData] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState(null);
  const [tempFilters, setTempFilters] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [initialUserRole, setInitialUserRole] = useState(null);
  const maxTextLength = 8;
  useEffect(() => {
    if (selectedFilters && filterData) {
      const userRole = filterData.user_Details.user_Role.toUpperCase();
      const selectedUserRole = selectedFilters.user_role.toUpperCase();
      const mappings = getCodeMappings(filterData);
      const { userIdMap, flmToReportsMap } = mappings;
  
      const selectedMRs = [];
      filterData.filter_Data.forEach((division) => {
        if (!selectedFilters.division.includes(division.divisionname)) return;
        division.zones.forEach((zone) => {
          if (!selectedFilters.zone.includes(zone.zonename)) return;
          zone.regions.forEach((region) => {
            if (!selectedFilters.region.includes(region.regionname)) return;
            region.hQs.forEach((hq) => {
              if (!selectedFilters.hq.includes(hq.hqname)) return;
              hq.employees.forEach((employee) => {
                if (employee.user_role.toUpperCase() !== "MR") return;
  
                const isSelected =
                  selectedUserRole === "MR"
                    ? selectedFilters.user_id.includes(employee.username)
                    : true; 
                let isReporting = true;
                if (
                  (selectedUserRole === "SLM" || selectedUserRole === "FLM") &&
                  selectedFilters.user_id.length > 0
                ) {
                  const selectedUserIds = selectedFilters.user_id.map(
                    (name) => userIdMap[name]
                  );
                  if (selectedUserRole === "SLM") {
                    
                    isReporting = true; 
                  } else if (selectedUserRole === "FLM") {
                   
                    isReporting = selectedUserIds.some((flmId) =>
                      flmToReportsMap[flmId]?.includes(employee.userid)
                    );
                  }
                }
  
                if (isSelected && isReporting) {
                  selectedMRs.push(employee.username);
                }
              });
            });
          });
        });
      });
      setSelectedMRs(selectedMRs.length)
     
      if (selectedUserRole === "MR") {
        console.log("List of selected MRs (MR Hierarchy):", selectedMRs);
        console.log("Count of selected MRs (MR Hierarchy):", selectedMRs.length);
      } else if (selectedUserRole === "SLM" && userRole === "SLM") {
        console.log("List of selected MRs (SLM Hierarchy):", selectedMRs);
        console.log("Count of selected MRs (SLM Hierarchy):", selectedMRs.length);
      } else if (selectedUserRole === "FLM" && userRole === "FLM") {
        console.log("List of selected MRs (FLM Hierarchy):", selectedMRs);
        console.log("Count of selected MRs (FLM Hierarchy):", selectedMRs.length);
      }
    }
  }, [selectedFilters, filterData]);

  const getAvailableUserIdOptions = (filterData, selectedFilters, currentFilter) => {
    if (selectedFilters.user_role === "MR") {
      return filterOptions.user_id;
    } else if (selectedFilters.user_role === "FLM") {
      const activeFilters = { ...selectedFilters };
      if (currentFilter !== "division") activeFilters.division = filterOptions.division;
      if (currentFilter !== "zone") activeFilters.zone = filterOptions.zone;
      if (currentFilter !== "region") activeFilters.region = filterOptions.region;
      if (currentFilter !== "hq") activeFilters.hq = filterOptions.hq;
      const relatedSelections = getRelatedSelections(
        filterData,
        "all",
        [],
        selectedFilters.user_role
      );
      return relatedSelections.user_id;
    }
    return filterOptions.user_id;
  };

  useEffect(() => {
    let userId = "demouser74@mankind.com";
    const userId2 = user_id;
    const finalUserId = userId2 ? userId2 : userId;
    fetch(
      `${API_BASE_URL}Filters/Filters?userId=${finalUserId}&userType=SAP_USER`
    )
      .then((response) => response.json())
      .then((data) => {
        setFilterData(data);
        setInitialUserRole(data.user_Details.user_Role.toUpperCase());
        const filterOptions = getAllFilterOptions(
          data,
          data.user_Details.user_Role
        );

        const initialFilters = {
          division: filterOptions.division,
          zone: filterOptions.zone,
          region: filterOptions.region,
          hq: filterOptions.hq,
          user_role: data.user_Details.user_Role.toUpperCase(),
          user_id: filterOptions.user_id,
          salesIn: filterOptions.salesIn[0],
          brandfamily: filterOptions.brandfamily,
          brand: filterOptions.brand,
          sku: filterOptions.sku,
        };

        setSelectedFilters(initialFilters);
        setTempFilters(initialFilters);
      })
      .catch((error) => {
        console.error("Error fetching filter data:", error);
      });
  }, [userId]);

  const convertToCodeFormat = (
    selectedFilters,
    mappings,
    userRole,
    filterData
  ) => {
    console.log(selectedMRs)
    const { divisionMap, zoneMap, regionMap, hqMap, flmToReportsMap, brandFamilyMap, brandMap, skuMap } =
      mappings;

    const userIds = getFilteredUserIds(
      filterData,
      selectedFilters,
      userRole,
      flmToReportsMap
    );

    return {
      divisioncode:
        selectedFilters?.division.map((name) => divisionMap[name]) || [],
      zonecode: selectedFilters?.zone.map((name) => zoneMap[name]) || [],
      regioncode: selectedFilters?.region.map((name) => regionMap[name]) || [],
      hqcode: selectedFilters?.hq.map((name) => hqMap[name]) || [],
      user_role: userRole === "SLM" ? "SLM" : "MR",
      user_id: userIds,
      months: [],
      brandfamilycode:
        selectedFilters?.brandfamily.map((name) => brandFamilyMap[name]) || [],
      brandcode: selectedFilters?.brand.map((name) => brandMap[name]) || [],
      sku: selectedFilters?.sku || [],
      Mr_Count:selectedMRs
    };
  };

  useEffect(() => {
    if (selectedFilters && filterData && initialUserRole  && selectedMRs!=0) {
      const mappings = getCodeMappings(filterData);
      const codeFormat = convertToCodeFormat(
        selectedFilters,
        mappings,
        initialUserRole,
        filterData
      );

      updateSalesUnit(selectedFilters.salesIn);

      fetch(`${API_BASE_URL}${apiEndpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(codeFormat),
      })
        .then((response) => response.json())
        .then((data) => {
          setLoading(false);
          setKpiData(data);
        })
        .catch((error) => {
          console.error("Initial API Error:", error);
        });
    }
  }, [filterData, initialUserRole, apiEndpoint,selectedMRs]);

  const singleSelectFilters = ["user_role", "salesIn"];

  const handleChange = (filter, event) => {
    const value = event.target.value;
    const filterOptions = getAllFilterOptions(
      filterData,
      selectedFilters.user_role
    );

    if (singleSelectFilters.includes(filter)) {
      if (filter === "user_role") {
        const newFilterOptions = getAllFilterOptions(filterData, value);
        const resetFilters = {
          division: newFilterOptions.division,
          zone: newFilterOptions.zone,
          region: newFilterOptions.region,
          hq: newFilterOptions.hq,
          user_role: value,
          user_id: newFilterOptions.user_id.filter((id) => !id.includes("No ")),
          salesIn: selectedFilters.salesIn,
          brandfamily: newFilterOptions.brandfamily,
          brand: newFilterOptions.brand,
          sku: newFilterOptions.sku,
        };

        setSelectedFilters(resetFilters);
        setTempFilters(resetFilters);

        const mappings = getCodeMappings(filterData);
        const codeFormat = convertToCodeFormat(
          resetFilters,
          mappings,
          value,
          filterData
        );

        fetch(`${API_BASE_URL}${apiEndpoint}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(codeFormat),
        })
          .then((response) => response.json())
          .then((data) => {
            setLoading(false);
            setKpiData(data);
          })
          .catch((error) => {
            console.error("Hierarchy Change API Error:", error);
          });
      } else {
        setSelectedFilters((prev) => {
          const updated = { ...prev, [filter]: value };
          if (filter === "salesIn") {
            updateSalesUnit(value);
          }
          return updated;
        });
        setTempFilters((prev) => ({
          ...prev,
          [filter]: value,
        }));
      }
      setOpenDropdown(null);
    } else {
      if (value.includes("all")) {
        const isSelectingAll =
          tempFilters[filter].length !== filterOptions[filter].length;
        setTempFilters((prev) => ({
          ...prev,
          [filter]: isSelectingAll ? [...filterOptions[filter]] : [],
        }));
      } else {
        setTempFilters((prev) => {
          const updated = { ...prev, [filter]: value };
          if (["division", "zone", "region", "hq", "user_id"].includes(filter)) {
            const relatedSelections = getRelatedSelections(
              filterData,
              filter,
              value,
              selectedFilters.user_role
            );
            return {
              ...updated,
              division:
                filter === "division"
                  ? value
                  : relatedSelections.division.length > 0
                  ? relatedSelections.division
                  : prev.division,
              zone:
                filter === "zone"
                  ? value
                  : relatedSelections.zone.length > 0
                  ? relatedSelections.zone
                  : prev.zone,
              region:
                filter === "region"
                  ? value
                  : relatedSelections.region.length > 0
                  ? relatedSelections.region
                  : prev.region,
              hq:
                filter === "hq"
                  ? value
                  : relatedSelections.hq.length > 0
                  ? relatedSelections.hq
                  : prev.hq,
              user_id:
                filter === "user_id"
                  ? value
                  : relatedSelections.user_id.length > 0
                  ? relatedSelections.user_id
                  : prev.user_id,
              brandfamily:
                relatedSelections.brandfamily.length > 0
                  ? relatedSelections.brandfamily
                  : prev.brandfamily,
              brand:
                relatedSelections.brand.length > 0
                  ? relatedSelections.brand
                  : prev.brand,
              sku:
                relatedSelections.sku.length > 0
                  ? relatedSelections.sku
                  : prev.sku,
            };
          } else if (["brandfamily", "brand", "sku"].includes(filter)) {
            const relatedSelections = getRelatedSelections(
              filterData,
              filter,
              value,
              selectedFilters.user_role
            );
            return {
              ...updated,
              brandfamily:
                filter === "brandfamily"
                  ? value
                  : relatedSelections.brandfamily.length > 0
                  ? relatedSelections.brandfamily
                  : prev.brandfamily,
              brand:
                filter === "brand"
                  ? value
                  : relatedSelections.brand.length > 0
                  ? relatedSelections.brand
                  : prev.brand,
              sku:
                filter === "sku"
                  ? value
                  : relatedSelections.sku.length > 0
                  ? relatedSelections.sku
                  : prev.sku,
            };
          }
          return updated;
        });
      }
    }
  };

  const handleApply = (filter) => {
    const newSelected = tempFilters[filter];
    const mappings = getCodeMappings(filterData);
    const filterOptions = getAllFilterOptions(
      filterData,
      selectedFilters.user_role
    );
    const multiSelectFilters = [
      "division",
      "zone",
      "region",
      "hq",
      "user_id",
      "brandfamily",
      "brand",
      "sku",
    ];

    setSelectedFilters((prev) => {
      let updatedFilters = { ...prev, [filter]: newSelected };

      if (
        multiSelectFilters.includes(filter) &&
        newSelected.length === filterOptions[filter].length
      ) {
        multiSelectFilters.forEach((multiFilter) => {
          updatedFilters[multiFilter] = [...filterOptions[multiFilter]];
        });
      } else {
        const relatedSelections = getRelatedSelections(
          filterData,
          filter,
          newSelected,
          selectedFilters.user_role
        );
        if (filter === "user_id") {
          updatedFilters.division =
            relatedSelections.division.length > 0
              ? relatedSelections.division
              : filterOptions.division;
          updatedFilters.zone =
            relatedSelections.zone.length > 0
              ? relatedSelections.zone
              : filterOptions.zone;
          updatedFilters.region =
            relatedSelections.region.length > 0
              ? relatedSelections.region
              : filterOptions.region;
          updatedFilters.hq =
            relatedSelections.hq.length > 0
              ? relatedSelections.hq
              : filterOptions.hq;
          updatedFilters.brandfamily =
            relatedSelections.brandfamily.length > 0
              ? relatedSelections.brandfamily
              : filterOptions.brandfamily;
          updatedFilters.brand =
            relatedSelections.brand.length > 0
              ? relatedSelections.brand
              : filterOptions.brand;
          updatedFilters.sku =
            relatedSelections.sku.length > 0
              ? relatedSelections.sku
              : filterOptions.sku;
        } else if (["division", "zone", "region", "hq"].includes(filter)) {
          updatedFilters.division =
            filter === "division"
              ? newSelected
              : relatedSelections.division.length > 0
              ? relatedSelections.division
              : filterOptions.division;
          updatedFilters.zone =
            filter === "zone"
              ? newSelected
              : relatedSelections.zone.length > 0
              ? relatedSelections.zone
              : filterOptions.zone;
          updatedFilters.region =
            filter === "region"
              ? newSelected
              : relatedSelections.region.length > 0
              ? relatedSelections.region
              : filterOptions.region;
          updatedFilters.hq =
            filter === "hq"
              ? newSelected
              : relatedSelections.hq.length > 0
              ? relatedSelections.hq
              : filterOptions.hq;
          updatedFilters.user_id =
            relatedSelections.user_id.length > 0
              ? relatedSelections.user_id
              : filterOptions.user_id;
          updatedFilters.brandfamily =
            relatedSelections.brandfamily.length > 0
              ? relatedSelections.brandfamily
              : filterOptions.brandfamily;
          updatedFilters.brand =
            relatedSelections.brand.length > 0
              ? relatedSelections.brand
              : filterOptions.brand;
          updatedFilters.sku =
            relatedSelections.sku.length > 0
              ? relatedSelections.sku
              : filterOptions.sku;
        } else if (["brandfamily", "brand", "sku"].includes(filter)) {
          updatedFilters.brandfamily =
            filter === "brandfamily"
              ? newSelected
              : relatedSelections.brandfamily.length > 0
              ? relatedSelections.brandfamily
              : filterOptions.brandfamily;
          updatedFilters.brand =
            filter === "brand"
              ? newSelected
              : relatedSelections.brand.length > 0
              ? relatedSelections.brand
              : filterOptions.brand;
          updatedFilters.sku =
            filter === "sku"
              ? newSelected
              : relatedSelections.sku.length > 0
              ? relatedSelections.sku
              : filterOptions.sku;
        }
      }

      const prevSelected = prev[filter];
      const hasChanged =
        JSON.stringify(newSelected.sort()) !==
        JSON.stringify(prevSelected.sort());

      if (hasChanged) {
        const codeFormat = convertToCodeFormat(
          updatedFilters,
          mappings,
          selectedFilters.user_role,
          filterData
        );
        fetch(`${API_BASE_URL}${apiEndpoint}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(codeFormat),
        })
          .then((response) => response.json())
          .then((data) => {
            setLoading(false);
            setKpiData(data);
          })
          .catch((error) => {
            console.error("API Error:", error);
          });
      }

      return updatedFilters;
    });

    setTempFilters((prev) => {
      const updatedTempFilters = { ...prev, [filter]: newSelected };
      if (
        multiSelectFilters.includes(filter) &&
        newSelected.length === filterOptions[filter].length
      ) {
        multiSelectFilters.forEach((multiFilter) => {
          updatedTempFilters[multiFilter] = [...filterOptions[multiFilter]];
        });
      } else {
        const relatedSelections = getRelatedSelections(
          filterData,
          filter,
          newSelected,
          selectedFilters.user_role
        );
        if (filter === "user_id") {
          updatedTempFilters.division =
            relatedSelections.division.length > 0
              ? relatedSelections.division
              : filterOptions.division;
          updatedTempFilters.zone =
            relatedSelections.zone.length > 0
              ? relatedSelections.zone
              : filterOptions.zone;
          updatedTempFilters.region =
            relatedSelections.region.length > 0
              ? relatedSelections.region
              : filterOptions.region;
          updatedTempFilters.hq =
            relatedSelections.hq.length > 0
              ? relatedSelections.hq
              : filterOptions.hq;
          updatedTempFilters.brandfamily =
            relatedSelections.brandfamily.length > 0
              ? relatedSelections.brandfamily
              : filterOptions.brandfamily;
          updatedTempFilters.brand =
            relatedSelections.brand.length > 0
              ? relatedSelections.brand
              : filterOptions.brand;
          updatedTempFilters.sku =
            relatedSelections.sku.length > 0
              ? relatedSelections.sku
              : filterOptions.sku;
        } else if (["division", "zone", "region", "hq"].includes(filter)) {
          updatedTempFilters.division =
            filter === "division"
              ? newSelected
              : relatedSelections.division.length > 0
              ? relatedSelections.division
              : filterOptions.division;
          updatedTempFilters.zone =
            filter === "zone"
              ? newSelected
              : relatedSelections.zone.length > 0
              ? relatedSelections.zone
              : filterOptions.zone;
          updatedTempFilters.region =
            filter === "region"
              ? newSelected
              : relatedSelections.region.length > 0
              ? relatedSelections.region
              : filterOptions.region;
          updatedTempFilters.hq =
            filter === "hq"
              ? newSelected
              : relatedSelections.hq.length > 0
              ? relatedSelections.hq
              : filterOptions.hq;
          updatedTempFilters.user_id =
            relatedSelections.user_id.length > 0
              ? relatedSelections.user_id
              : filterOptions.user_id;
          updatedTempFilters.brandfamily =
            relatedSelections.brandfamily.length > 0
              ? relatedSelections.brandfamily
              : filterOptions.brandfamily;
          updatedTempFilters.brand =
            relatedSelections.brand.length > 0
              ? relatedSelections.brand
              : filterOptions.brand;
          updatedTempFilters.sku =
            relatedSelections.sku.length > 0
              ? relatedSelections.sku
              : filterOptions.sku;
        } else if (["brandfamily", "brand", "sku"].includes(filter)) {
          updatedTempFilters.brandfamily =
            filter === "brandfamily"
              ? newSelected
              : relatedSelections.brandfamily.length > 0
              ? relatedSelections.brandfamily
              : filterOptions.brandfamily;
          updatedTempFilters.brand =
            filter === "brand"
              ? newSelected
              : relatedSelections.brand.length > 0
              ? relatedSelections.brand
              : filterOptions.brand;
          updatedTempFilters.sku =
            filter === "sku"
              ? newSelected
              : relatedSelections.sku.length > 0
              ? relatedSelections.sku
              : filterOptions.sku;
        }
      }
      return updatedTempFilters;
    });

    setOpenDropdown(null);
  };

  const handleCancel = (filter) => {
    setTempFilters((prev) => ({ ...prev, [filter]: selectedFilters[filter] }));
    setOpenDropdown(null);
  };

  const handleOpen = (filter) => {
    setTempFilters((prev) => ({ ...prev, [filter]: selectedFilters[filter] }));
    setOpenDropdown(filter);
  };

  const getFilteredUserIds = (
    filterData,
    selectedFilters,
    userRole,
    flmToReportsMap
  ) => {
    const userIds = new Set();

    if (
      selectedFilters?.user_role === "MR" &&
      selectedFilters?.user_id?.length > 0
    ) {
      let found = false;
      filterData?.filter_Data?.forEach((division) => {
        division.zones.forEach((zone) => {
          zone.regions.forEach((region) => {
            region.hQs.forEach((hq) => {
              hq.employees.forEach((employee) => {
                if (
                  employee.user_role.toUpperCase() === "MR" &&
                  employee.userid &&
                  selectedFilters.user_id.includes(employee.username)
                ) {
                  userIds.add(employee.userid);
                  found = true;
                }
              });
            });
          });
        });
      });
      if (!found) {
        console.warn("No MR employees found for the selected user IDs.");
      }
      return Array.from(userIds);
    }

    if (
      userRole === "SLM" &&
      selectedFilters?.user_role === "MR" &&
      selectedFilters?.user_id?.length > 0
    ) {
      let found = false;
      filterData?.filter_Data?.forEach((division) => {
        division.zones.forEach((zone) => {
          zone.regions.forEach((region) => {
            region.hQs.forEach((hq) => {
              hq.employees.forEach((employee) => {
                if (
                  employee.user_role.toUpperCase() === "MR" &&
                  employee.userid &&
                  selectedFilters.user_id.includes(employee.username)
                ) {
                  userIds.add(employee.userid);
                  found = true;
                }
              });
            });
          });
        });
      });
      if (!found) {
        console.warn("No MR employees found for the selected user IDs.");
      }
      return Array.from(userIds);
    }

    if (userRole === "SLM" && filterData?.user_Details?.user_Id) {
      userIds.add(filterData.user_Details.user_Id);
    }

    filterData?.filter_Data?.forEach((division) => {
      division.zones.forEach((zone) => {
        zone.regions.forEach((region) => {
          if (
            selectedFilters?.region?.length > 0 &&
            !selectedFilters.region.includes(region.regionname)
          ) {
            return;
          }
          region.hQs.forEach((hq) => {
            hq.employees.forEach((employee) => {
              if (
                employee.user_role.toUpperCase() === "MR" &&
                employee.userid
              ) {
                userIds.add(employee.userid);
              }
              if (
                employee.manager_role?.toUpperCase() === "FLM" &&
                employee.reporting_manager_id
              ) {
                userIds.add(employee.reporting_manager_id);
              }
            });
          });
        });
      });
    });

    if (userRole === "FLM" && selectedFilters?.user_id?.length > 0) {
      const flmUserId = filterData.user_Details.user_Id;
      if (selectedFilters.user_id.includes(filterData.user_Details.userName)) {
        userIds.add(flmUserId);
      }
      const reportingUserIds = selectedFilters.user_id
        .filter((username) => flmToReportsMap[filterData.user_Details.user_Id])
        .flatMap(() => flmToReportsMap[filterData.user_Details.user_Id] || []);
      reportingUserIds.forEach((id) => userIds.add(id));
    }

    return Array.from(userIds);
  };

  const getFlmManagerNames = (filterData) => {
    const flmManagerNames = new Set();
    filterData.filter_Data.forEach((division) => {
      division.zones.forEach((zone) => {
        zone.regions.forEach((region) => {
          region.hQs.forEach((hq) => {
            hq.employees.forEach((employee) => {
              if (
                employee.manager_role?.toUpperCase() === "FLM" &&
                employee.manager_name &&
                employee.manager_name !== ""
              ) {
                flmManagerNames.add(employee.manager_name);
              }
            });
          });
        });
      });
    });
    return Array.from(flmManagerNames).length > 0
      ? Array.from(flmManagerNames)
      : ["No FLM Managers Found"];
  };
  const selectStyles = {
    maxWidth: 120,
    height: 22,
    borderRadius: "1px",
    borderWidth: "1px",
    gap: "4px",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px",
    textTransform: "uppercase",
    padding: "0",
    "& .MuiSelect-select": {
      width: "100%",
      textTransform: "uppercase",
      textOverflow: "clip",
      whiteSpace: "nowrap",
      overflow: "hidden",
      padding: "14px",
      paddingTop: "18px",
    },
    "& .MuiSelect-icon": {
      marginLeft: "20px",
      right: "5px",
    },
  };

 const loadingOrEmptyState = renderLoadingOrEmptyState(
    filterData,
    selectedFilters,
    tempFilters
  );
  if (loadingOrEmptyState) {
    return loadingOrEmptyState;
  }

  const filterOptions = getAllFilterOptions(
    filterData,
    selectedFilters.user_role
  );

  return (
    <div className="filter-container brand-filter">
      <img src={FilterListIcon} alt="Filter Icon" className="filter-icon" />
      <Grid container spacing={1} sx={{
    flexWrap: {
      xs: "wrap",      
      md: "nowrap",   
    },
  }}>
        {Object.keys(filterOptions).map((filter) => (
          <Grid item xs={2} key={filter}>
            <InputLabel
              sx={{
                textTransform: "capitalize",
                fontWeight: 400,
                fontSize: "14px",
                padding: "3px 3px",
                color: "red",
              }}
            >
           
                {filter === "user_role"
    ? "Hierarchy"
    : filter === "user_id"
    ? "Employee"
    : filter === "hq"
    ? "HQ"
    : filter}
            </InputLabel>
            <FormControl fullWidth>
              <Select
                multiple={!singleSelectFilters.includes(filter)}
                open={openDropdown === filter}
                onOpen={() => handleOpen(filter)}
                onClose={() => {
                  setTempFilters((prev) => ({
                    ...prev,
                    [filter]: selectedFilters[filter],
                  }));
                  setOpenDropdown(null);
                }}
                value={
                  singleSelectFilters.includes(filter)
                    ? selectedFilters[filter]
                    : tempFilters[filter]
                }
                onChange={(event) => handleChange(filter, event)}
                renderValue={(selected) => {
                  const availableOptions = filterOptions[filter] || [];

if (
  !singleSelectFilters.includes(filter) &&
  Array.isArray(selected) &&
  selected.length === availableOptions.length &&
  selected.every((item) => availableOptions.includes(item))
) {
  const text = "ALL selected";
        return text.length > maxTextLength
          ? `${text.substring(0, maxTextLength)}..`
          : text;
}
                  if (filter === "user_id") {
                    const userName = filterData.user_Details.userName;
                    if (
                      initialUserRole === "SLM" &&
                      selectedFilters.user_role === "SLM"
                    ) {
                      const text = userName || "No Name";
                      return text.length > maxTextLength
                        ? `${text.substring(0, maxTextLength)}...`
                        : text;
                    }
                    if (
                      initialUserRole === "FLM" &&
                      selectedFilters.user_role === "FLM"
                    ) {
                      const text = userName || "No Name";
                      return text.length > maxTextLength
                        ? `${text.substring(0, maxTextLength)}...`
                        : text;
                    }
                    if (selectedFilters.user_role === "FLM") {
                      const currentUserIds =
                        tempFilters.user_id.length > 0
                          ? tempFilters.user_id
                          : selectedFilters.user_id;
                      const flmNames = currentUserIds.filter((id) =>
                        filterData.filter_Data.some((division) =>
                          division.zones.some((zone) =>
                            zone.regions.some((region) =>
                              region.hQs.some((hq) =>
                                hq.employees.some(
                                  (emp) =>
                                    emp.manager_role?.toUpperCase() === "FLM" &&
                                    emp.manager_name === id
                                )
                              )
                            )
                          )
                        )
                      );
                      const text =
                        flmNames.length > 0
                          ? flmNames[0]
                          : currentUserIds.length > 0
                          ? currentUserIds[0]
                          : "No Employees";
                      return text.length > maxTextLength
                        ? `${text.substring(0, maxTextLength)}...`
                        : text;
                    }
                    if (selectedFilters.user_role === "MR") {
                      const currentUserIds =
                        tempFilters.user_id.length > 0
                          ? tempFilters.user_id
                          : selectedFilters.user_id;
                      const text =
                        currentUserIds.length > 0
                          ? currentUserIds[0]
                          : "No Employees";
                      return text.length > maxTextLength
                        ? `${text.substring(0, maxTextLength)}...`
                        : text;
                    }
                    const currentUserIds =
                      tempFilters.user_id.length > 0
                        ? tempFilters.user_id
                        : selectedFilters.user_id;
                    const text =
                      currentUserIds.length > 0
                        ? currentUserIds[0]
                        : "No Employees";
                    return text.length > maxTextLength
                      ? `${text.substring(0, maxTextLength)}...`
                      : text;
                  }
                  if (filter === "sku") {
                    const mappings = getCodeMappings(filterData);
                    const text = Array.isArray(selected)
                      ? selected
                          .map((sku) => mappings.skuMap[sku] || sku)
                          .join(", ")
                      : mappings.skuMap[selected] || selected;
                    return text.length > maxTextLength
                      ? `${text.substring(0, maxTextLength)}...`
                      : text;
                  }

                  
                  const text = Array.isArray(selected)
                    ? selected.join(", ")
                    : selected;
                  return text.length > maxTextLength
                    ? `${text.substring(0, maxTextLength)}...`
                    : text;
                }}
                sx={selectStyles}
                size="large"
              >
                {!singleSelectFilters.includes(filter) && (
                  <MenuItem value="all">
                    <Checkbox
                      
                      checked={
                      filter === "user_id" && selectedFilters.user_role === "FLM"
                        ? getFlmManagerNames(filterData).every((manager) =>
                            tempFilters[filter].includes(manager)
                          ) &&
                          tempFilters[filter].every((selected) =>
                            getFlmManagerNames(filterData).includes(selected)
                          )
                        : tempFilters[filter].length ===
                          (filter === "user_id"
                            ? getAvailableUserIdOptions(
                                filterData,
                                selectedFilters,
                                filter
                              ).length
                            : filterOptions[filter].length)
                    }
                      sx={{
                        transform: "scale(0.8)",
                        padding: "0 !important",
                        "& .MuiSvgIcon-root": { fontSize: "19px" },
                      }}
                    />
                    <ListItemText
                      primary="Select All"
                      primaryTypographyProps={{ fontSize: "12px !important" }}
                      sx={{
                        padding: "0 !important",
                        textTransform: "uppercase",
                      }}
                    />
                  </MenuItem>
                )}
                {filterOptions[filter].map((option) => (
                  <MenuItem key={option} value={option}>
                    {!singleSelectFilters.includes(filter) && (
                      <Checkbox
                        checked={tempFilters[filter].includes(option)}
                        sx={{
                          transform: "scale(0.8)",
                          padding: "0 !important",
                          "& .MuiSvgIcon-root": { fontSize: "19px" },
                        }}
                      />
                    )}
                    <ListItemText
                      primary={
                        filter === "sku"
                          ? getCodeMappings(filterData).skuMap[option] || option
                          : option
                      }
                      primaryTypographyProps={{ fontSize: "12px !important" }}
                      sx={{
                        padding: "0 !important",
                        textTransform: "uppercase",
                      }}
                    />
                  </MenuItem>
                ))}
                {!singleSelectFilters.includes(filter) && (
                  <Box display="flex" justifyContent="space-between" p={0}>
                    <StyledButton
                      variant="contained"
                      color="primary"
                      onClick={() => handleApply(filter)}
                      disabled={tempFilters[filter].length === 0}
                    >
                      Apply
                    </StyledButton>
                    <StyledButton
                      variant="outlined"
                      color="secondary"
                      onClick={() => handleCancel(filter)}
                    >
                      Cancel
                    </StyledButton>
                  </Box>
                )}
              </Select>
            </FormControl>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default MultiFilterSelect;